module.exports = __webpack_public_path__ + "static/img/cycleAI-90.69198d1.svg";